<template>
  <div class="tresult-edit">
    <div class="tresult-edit__student-info">
      <div class="row row-header">
        <b>Группа</b>
        <b>ФИО</b>
        <b>Дисциплина</b>
        <b>Тип работы</b>
      </div>
      <div class="row row-data">
        <span>{{ componentData.value.user.group.name }}</span>
        <span>{{ componentData.value.user.name }}</span>
        <span>{{ componentData.value.discipline.name }}</span>
        <span>{{ componentData.value.work.name }}</span>
      </div>
    </div>
    <div class="tresult-edit__form">
      <div class="tresult-edit__left-section">
        <el-input
          @input="clearErrors"
          :class="[{ 'el-input--error': form.commentTeacher.error }]"
          maxlength="1000"
          show-word-limit
          type="textarea"
          placeholder="Комментарий преподавателя"
          size="small"
          :autosize="{ minRows: 2, maxRows: 4 }"
          v-model="form.commentTeacher.value"
          ref="teacher-comment"
        >
        </el-input>
       
        <el-select
          v-if="!componentData.value.vkr_id"
          v-model="form.result.value"
          placeholder="Выберите оценку"
          :disabled="form.returnToModification.value"
        >
          <el-option
            v-for="(result, index) in componentData.value.resultList"
            :key="index"
            action=""
            :label="result.title"
            :value="result.title"
          >
          </el-option>
        </el-select>
        <el-input
          :class="[{ 'el-input--error': form.commentCurator.error }]"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="Комментарий для куратора"
          v-model="form.commentCurator.value"
        >
        </el-input>

        <template v-if="true">
          <el-checkbox
            :class="[{ 'el-input--error': form.returnToModification.error }]"
            @change="returnToModificationHandler"
            v-model="form.returnToModification.value"
            >Отправить на доработку</el-checkbox
          >
          <el-checkbox
            :class="[{ 'el-input--error': form.workAccepted.error }]"
            @change="workAcceptedHandler"
            v-model="form.workAccepted.value"
            >Работа принята без замечаний</el-checkbox
          >
          <div
            :class="[
              'upload_button',
              { uploadFileDone: form.file.value },
              { 'el-input--error': form.file.error },
            ]"
          >
            <div class="upload-file">
              <label for="file" class="upload-file__label">
                <i class="action-bord__item-icon el-icon-upload2"></i>
                <span class="upload-file__label-text" v-if="!form.file.value"
                  >Загрузить файл</span
                >
                <button class="upload-file__button" v-else>
                  Файл загружен
                </button>
              </label>
              <el-button
                class="action-bord__button-close"
                type="text"
                icon="el-icon-close"
                @click="cancelUpload($event)"
                v-if="form.file.value"
              ></el-button>
              <input
                class="upload-file__input"
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
              />
            </div>
          </div>

          <div class="buttons-wrp">
            <el-button type="primary" @click="submitForm()"
              >Сохранить</el-button
            >
            <el-button @click="clearForm()">Отмена</el-button>
          </div>
        </template>
      </div>
      <div class="tresult-edit__right-section">
        <b>Комментарий студента:</b>
        <p>
          {{
            componentData.value.comm
              ? componentData.value.comm
              : "Нет коментариев"
          }}
        </p>
        <a :href="componentData.value.upload" download target="blank"
          ><i class="el-icon-download"></i>Скачать работу студента</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        commentTeacher: {
          value: "",
          error: false,
        },
        commentCurator: {
          value: "",
          error: false,
        },
        result: {
          value: "",
          error: false,
        },
        file: {
          value: "",
          error: false,
        },
        returnToModification: {
          value: false,
          error: false,
        },
        workAccepted: {
          value: "",
          error: false,
        },
      },
      supporting: {
        resultList: [],
      },
      checkList: {
        other: [
          {
            name: "commentTeacher",
            badValue: "",
            condition: null,
          },
        ],
        app: [
          {
            name: "commentTeacher",
            badValue: "",
            condition: null,
          },
        ],
        plan: [
          {
            name: "commentTeacher",
            badValue: "",
            condition: "||",
          },
          {
            name: "file",
            badValue: "",
            condition: null,
          },
        ],
        review: [
          {
            name: "commentTeacher",
            badValue: "",
            condition: "||",
          },
          {
            name: "file",
            badValue: "",
            condition: null,
          },
        ],
        work: [
          {
            name: "commentTeacher",
            badValue: "",
            condition: "||",
          },
          {
            name: "file",
            badValue: "",
            condition: null,
          },
        ],
      },
    };
  },
  props: {
    componentData: Object,
  },
  computed: {
    enterPoint() {
      return this.$store.state.enterPoint;
    },
    // dsabledInput(){
    //   if(this.componentData.value.double){
    //     if(this.componentData.value.double_last_result){
    //       return true
    //     }
    //     return false
    //   }
    //   return this.form.returnToModification.value
    // }
  },
  methods: {
    clearErrors() {
      for (let key in this.form) {
        this.form[key].error = false;
      }
    },
    returnToModificationHandler(value) {
      this.form.workAccepted.error = false;
      this.form.returnToModification.error = false;
      if (value) this.form.workAccepted.value = false;
    },
    workAcceptedHandler(value) {
      this.form.workAccepted.error = false;
      this.form.returnToModification.error = false;
      if (value) this.form.returnToModification.value = false;
    },
    handleFileUpload() {
      this.form.file.value = this.$refs.file.files[0];
      this.clearErrors();
    },
    checkForm() {
      const h = this.$createElement;
      if (
        !this.form.returnToModification.value &&
        !this.form.workAccepted.value
      ) {
        this.form.returnToModification.error = true;
        this.form.workAccepted.error = true;
        return false;
      }
      if (this.form.returnToModification.value) {
        let typeVkr = this.componentData.value.type
          ? this.componentData.value.type
          : "other";
        let rules = this.checkList[typeVkr];
        let resultArray = rules.map((rule) => {
          let value = this.form[rule.name].value;
          let result = value !== rule.badValue;
          rule.result = result;
          if (rule.condition) result += `${rule.condition}`;
          return result;
        });

        let checkResult = eval(`Boolean(${resultArray.join("")})`);
        if (!checkResult) {
          this.$notify({
            message: h(
              "i",
              { style: `color: #E6A23C` },
              "Не все поля заполнены"
            ),
          });
          rules.forEach((rule) => {
            if (!rule.result) this.form[rule.name].error = true;
          });
          return false;
        }
        return true;
      }
      return true;
    },
    cancelUpload(e) {
      e.stopPropagation();
      this.form.file.value = "";
      this.$refs.file.value = "";
    },
    preparingFile() {
      const data = new FormData();
      data.append("file", this.form.file);
      data.append("type", "file");
      return data;
    },
    submitForm() {
      let resultCheck = this.checkForm();
      if (!resultCheck) return;
      const data = new FormData();
      this.form.file.value ? data.append("file", this.form.file.value) : null;
      this.form.commentTeacher.value
        ? data.append("tcomm", this.form.commentTeacher.value)
        : null;
      this.form.commentCurator.value
        ? data.append("ccomm", this.form.commentCurator.value)
        : null;
      this.form.returnToModification.value
        ? data.append("resend", Number(this.form.returnToModification.value))
        : null;
      this.form.result.value
        ? data.append("result", this.form.result.value)
        : null;
      this.form.workAccepted.value
        ? data.append("no_comments", this.form.workAccepted.value)
        : null;
      this.form.file.value.name
        ? data.append("file_name", this.form.file.value.name)
        : null;
      this.componentData.value.vkr_number
        ? data.append("vkr_number", this.componentData.value.vkr_number)
        : null;
      this.axios
        .post(
          `api/results/${this.$route.params.did}/wresults/${this.componentData.value.id}`,
          data
        )
        .then((res) => {
          if (res.data.status) {
            this.$emit("close");
            if (
              this.componentData.value.vkr_id &&
              this.form.returnToModification.value
            ) {
              const h = this.$createElement;
              this.$notify({
                message: h(
                  "i",
                  { style: `color: #E6A23C` },
                  "Работа отправлена на доработку"
                ),
              });
              this.componentData.cb(
                `api/results/${this.$route.params.did}/wresults`
              );
              return;
            }
            this.notify(true, "Работа проверена");
            this.componentData.cb(
              `api/results/${this.$route.params.did}/wresults`
            );
          } else {
            this.notify(false, res.data.message);
          }
        });
    },
    clearForm() {
      for (let key in this.form) {
        typeof this.form[key] === "boolean"
          ? (this.form[key] = false)
          : (this.form[key] = "");
      }
    },
    notify(status, text) {
      const h = this.$createElement;
      this.$notify({
        title: "",
        message: h(
          "i",
          { style: `color: ${status ? "#67C23A" : " #f56c6c"}` },
          text
        ),
      });
    },
  },
  mounted() {
    this.form.commentTeacher.value = this.componentData.value.tcomm
      ? this.componentData.value.tcomm
      : "";
    this.form.commentCurator.value = this.componentData.value.ccomm
      ? this.componentData.value.ccomm
      : "";
    if (!this.componentData.value.double) {
      if (this.componentData.value.result) {
        this.form.result.value = this.componentData.value.result;
      }
    } else {
      if (this.componentData.value.double_last_result) {
        this.form.result.value = this.componentData.value.double_last_result;
      }else{
        this.form.result.value = this.componentData.value.result;
      }
    }
  },
};
</script>

<style lang="scss">
.tresult-edit {
  height: 90%;
  display: grid;
  grid-template-rows: max-content auto;
  row-gap: 10px;
  overflow-y: auto;
  .tresult-edit__student-info {
    display: grid;
    row-gap: 10px;
    grid-template-rows: auto;
    .row {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      justify-items: center;
      align-items: center;
    }
    .row-header {
      border-bottom: 1px solid $placeholder-text-clr;
      padding-bottom: 10px;
    }
    .row-data {
      color: $secondary-text-clr;
      border-bottom: 1px solid $placeholder-text-clr;
    }
    span {
      text-align: center;
    }
  }
  .tresult-edit__form {
    display: grid;
    column-gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
  .tresult-edit__right-section {
    display: grid;
    grid-template-rows: max-content max-content max-content;
    row-gap: 10px;
    p {
      background-color: $brand-clr-1;
      color: $basic-white;
      padding: 10px;
      border-radius: 10px;
    }
    a {
      color: $brand-clr-1;
      transition-duration: 0.3s;
      transition-property: color;
      i {
        font-size: 20px;
      }
      &:hover {
        color: lighten($color: $brand-clr-1, $amount: 10%);
      }
    }
  }
  .tresult-edit__left-section {
    display: grid;
    grid-template-rows: repeat(max-content);
    row-gap: 10px;
    align-items: flex-start;
    height: max-content;
    max-height: 100%;
  }
  .el-input--error {
    border-color: $danger-clr !important;
    .el-textarea__inner {
      border-color: $danger-clr;
    }
    .el-checkbox__inner {
      border-color: $danger-clr;
    }
  }
  .el-textarea__inner::-webkit-resizer {
    background-color: transparent;
  }
  .upload_button {
    max-width: 185px;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid $placeholder-text-clr;
    color: $regular-text-clr;
    &:hover {
      background-color: rgba($color: $brand-clr-1, $alpha: 0.05);
      color: $brand-clr-1;
    }
  }
  .upload-file {
    display: flex;
    position: relative;
    padding: 10px;
    justify-content: space-between;
    .action-bord__button-close {
      padding: 0;
      color: $basic-white;
    }
  }
  .upload-file__label {
    width: 100%;
    text-align: center;
    i {
      margin-right: 10px;
    }
  }
  .upload-file__label-text {
    font-size: 12px;
  }
  .uploadFileDone {
    background-color: $success-clr;
    color: $basic-white;
    .el-icon-upload2 {
      color: $basic-white;
    }
    &:hover {
      background-color: lighten($color: $success-clr, $amount: 10%);
    }
    .upload-file__button {
      color: $basic-white;
    }
  }
  .upload-file__input {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    position: absolute;
  }
}
@media (max-width: 800px) {
  .tresult-edit {
    padding: 10px 10px 10px 0;
    row-gap: 10px;
    .tresult-edit__student-info {
      grid-template-columns: max-content 1fr;
      column-gap: 10px;
      border-bottom: 1px solid $brand-clr-1;
      padding-bottom: 10px;
      .row-header {
        width: max-content;
        padding: 0;
        row-gap: 10px;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 3fr 1fr;
        border: none;
      }
      .row-data {
        padding: 0;
        row-gap: 10px;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 3fr 1fr;
        border: none;
      }
    }
    .tresult-edit__form {
      grid-template-columns: 1fr;
      row-gap: 10px;
    }
    .tresult-edit__right-section {
      grid-row-start: 1;
    }
  }
}
</style>
